// extracted by css-extract-rspack-plugin
export default {"skeletonRow":"skeletonRow-fHT3Vw","skeletonBar":"skeletonBar-lI4Ex7"};